import { CSSProperties, useRef } from 'react'
import { useDraggable } from '@dnd-kit/core'
import type { DraggableAttributes } from '@dnd-kit/core'
import { IBaseMediaItem, MediaStatus } from 'types/media'

type TDraggableListeners = ReturnType<typeof useDraggable>['listeners']

export interface ISidebarDragProps {
  setNodeRef: (node: HTMLElement | null) => void
  listeners: TDraggableListeners
  attributes: DraggableAttributes
  isDragging: boolean
  style: CSSProperties
}

export const useSidebarItemDrag = (
  item: IBaseMediaItem | null
): ISidebarDragProps => {
  const isPending = item === null || item?.status === MediaStatus.PENDING
  // One stable uuid per component instance — guarantees no dragId collisions
  // across sources (library vs. history versions) that might share domain ids.
  const dragIdRef = useRef<string>(crypto.randomUUID())

  const { setNodeRef, listeners, attributes, isDragging } = useDraggable({
    id: dragIdRef.current,
    data: { item },
    disabled: isPending
  })

  const style: CSSProperties = isPending
    ? {}
    : { cursor: isDragging ? 'grabbing' : 'grab' }

  return { setNodeRef, listeners, attributes, isDragging, style }
}
